// extracted by mini-css-extract-plugin
export default {"shiftListContent":"ShiftList_shiftListContent__K+rIA"};